var _style, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 27",
    style: {
      enableBackground: "new 0 0 12 27"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#042b62;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.6,2.2h1.4c0.3,0,0.6-0.3,0.6-0.6s-0.3-0.6-0.6-0.6H8.1C7.6,0.4,6.8,0,5.9,0C4.6,0,3.5,1,3.3,2.2h4.4H8.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.9,5.4c1.4,0,2.6-1.1,2.7-2.5H3.2C3.4,4.3,4.5,5.4,5.9,5.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.8,15.1l-1.1-7.7c-0.1-0.5-0.5-0.9-1.1-0.9c-1.6,0-2.9,0-3.7,0c-1.3,0-0.3,10.9,0,10.9s0.4,0.2,0.4,0.4v7.8 c0,0.7,0.5,1.3,1.2,1.3c0.8,0,1.4-0.6,1.4-1.3l0-15.1l0.7,4.9c0.1,0.5,0.5,0.9,1.1,0.9c0.1,0,0.1,0,0.2,0 C11.5,16.2,11.9,15.6,11.8,15.1z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,15.1l1.1-7.7c0.1-0.5,0.5-0.9,1.1-0.9c1.6,0,2.9,0,3.7,0c1.3,0,0.3,10.9,0,10.9s-0.4,0.2-0.4,0.4v7.8 c0,0.7-0.5,1.3-1.2,1.3c-0.8,0-1.4-0.6-1.4-1.3l0-15.1l-0.7,4.9c-0.1,0.5-0.5,0.9-1.1,0.9c-0.1,0-0.1,0-0.2,0 C0.3,16.2-0.1,15.6,0,15.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSon);
export default __webpack_public_path__ + "static/media/son.26d3d55f9c0be357f7886091d95a4c7a.svg";
export { ForwardRef as ReactComponent };